module.exports = __webpack_public_path__ + "static/media/Ks.a2fd7deb.svg";